// removed by extract-text-webpack-plugin
module.exports = {"popoverZIndex":"19","popoverOZIndex":"21","footer":"Footer__footer___2nhzB","wrapper":"Footer__wrapper___1bSst","column":"Footer__column___2s5Kw","paymentColumn":"Footer__paymentColumn___xxJx5","columnHeader":"Footer__columnHeader___2Unkk","shareIconsContainer":"Footer__shareIconsContainer___1K78v","versionContainer":"Footer__versionContainer___1-Heb","text":"Footer__text___tTplm","linksContainer":"Footer__linksContainer___2aQ9U","contacts":"Footer__contacts___1tiIR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Footer/Footer.scss
 ** module id = 879
 ** module chunks = 0
 **/